export enum BadgeTypes {
  bronze = "bronze",
  silver = "silver",
  gold = "gold",
  diamond = "diamond",

  penalty = "penalty",
  penaltyTwo = "penaltyTwo",
}

export enum BadgeCategory {
  feedback = "feedback",
  participant = "participant",
  solution = "solution",
  patreon = "patreon",
  penalty = "penalty",
}

export enum BadgeNames {
  Enlightened = "enlightened",
  Reviewer = "reviewer",
  Guru = "guru",
  Illuminator = "illuminator",

  Beloved = "beloved",
  Perfection = "perfection",
  Epic = "epic",
  Legandary = "legandary",

  Tutor = "tutor",
  Feedbacker = "feedbacker",
  Teacher = "teacher",
  Professor = "professor",

  Solver = "solver",
  Developer = "developer",
  ChallengeCrusher = "challengeCrusher",
  SolutionExpert = "solutionExpert",
  SolutionHero = "solutionHero",

  WeeklyPopulist = "weeklyPopulist",
  MonthlyPopulist = "monthlyPopulist",

  Supporter = "supporter",
  Honor = "honor",
  marvelouser = "marvelouser",
  DiamondSupporter = "diamondSupporter",

  Incontructive = "incontructive",
  Spam = "spam",
}
